import React from 'react';
import Alert from './alert';

interface Props {
  isErrored: boolean;
  errorMsg?: string[];
}

export default function ErrorHandler(props: Props) {
  const { isErrored, errorMsg } = props;

  if (!isErrored) {
    return null;
  }

  return (
    <div className="alert-container">
      {!errorMsg ? (
        <Alert danger alignCenter>
          Something went wrong. Please refresh the page
        </Alert>
      ) : (
        errorMsg.map((message, index) => (
          <Alert key={index} danger alignCenter>
            {message}
          </Alert>
        ))
      )}
    </div>
  );
}
